// extracted by mini-css-extract-plugin
module.exports = {"PraktikKinerjaItem":"PraktikKinerja_PraktikKinerjaItem__kUwhY"};